const translations = {
  "en": {
    "Total": "Total"
  },
  "zh-tw": {
    "Total": "總計"
  }
};

export default translations;
